import React from 'react';
import { NextArrow, PrevArrow } from './slider-arrows';

export const sliderSettings = {
  dots: true,
  infinite: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 10000,
  nextArrow: <NextArrow />,
  prevArrow: <PrevArrow />,
};
